export default {"src":"/_next/static/media/Path.a5999655.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};